module.exports = __webpack_public_path__ + "static/img/bg-tr.d18b09e6.webp";